import { Input } from '@mantine/core';
import type { Key } from 'react';
import { IMaskInput as Mask } from 'react-imask';

interface PhoneNumberInputProps {
	label?: string;
	key: Key;
	[key: string]: any;
}

export function PhoneNumberInput({
	label,
	key,
	...otherProps
}: PhoneNumberInputProps) {
	return (
		<>
			<Input.Wrapper label={label ?? 'Phone Number'} key={key} {...otherProps}>
				<Input
					component={Mask}
					mask={'00000 000000'}
					placeholder={'Insert phone number...'}
					key={key}
					{...otherProps}
				/>
			</Input.Wrapper>
		</>
	);
}
